import React, { useContext, useEffect, useState } from "react";

import { Link, useParams } from "react-router-dom";
import useCheckOutItem from "../../hooks/useCheckout";
import useServices from "../../hooks/useServices";
import { CartContext } from "../Shared/Context/CartContext";
import "./ServiceDetail.css";

const ServiceDetail = () => {
  const { serviceId } = useParams();
  const [services, setServices] = useState([]);
  let orderService = [];

  useEffect(() => {
    fetch(
      "https://raw.githubusercontent.com/arshadsa/mern-stack/main/services.json"
    )
      .then((res) => res.json())
      .then((data) => setServices(data));
  }, []);

  orderService = services.find(service => service.id == serviceId)

  const cart = useContext(CartContext);

  return (
    <div className="service-container">
      <h2>You have choosen: {orderService?.name}</h2>
      <p>{orderService?.description}</p>
      <h4>Price: £{orderService?.price}</h4>
      <div className="text-center">
        <Link to="/checkout" onClick={() => cart.setCart(orderService)} >
          <button className="btn btn-primary">Proceed Checkout</button>
        </Link>
      </div>
    </div>
  );
};

export default ServiceDetail;
